import { render, staticRenderFns } from "./AllDeals.vue?vue&type=template&id=6a7c99d5&scoped=true"
import script from "./AllDeals.vue?vue&type=script&lang=js"
export * from "./AllDeals.vue?vue&type=script&lang=js"
import style0 from "./AllDeals.vue?vue&type=style&index=0&id=6a7c99d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7c99d5",
  null
  
)

export default component.exports